export default __webpack_public_path__ + "static/2.5.4/media/batteriesEditBanner.641e2d05.svg";